import { Injectable } from '@angular/core';
import { catchError, Observable, of, shareReplay, tap } from 'rxjs';
import { ApiCore } from 'src/app/config/api';
import { ApiService } from 'src/app/core/http/api.service';

@Injectable({
  providedIn: 'root',
})
export class ShareOrderGamesService {
  private listCategories$?: Observable<any>;

  constructor(private readonly apiService: ApiService) {
    this.listCategories$ = this.apiService.list(ApiCore.CATEGO_GAMES).pipe(
      tap((data: any) => {}),
      catchError((error) => {
        return of(null);
      }),
      shareReplay(1)
    );
  }

  getCategories(): Observable<any> {
    return this.listCategories$!;
  }
}
